import apiUrls from '../../youwell-common/apiUrls';
import ReduxStoreHelper from '../../youwell-common/ReduxStoreHelper';

const ACTION_PREFIX = 'USER';

const storeHelper = new ReduxStoreHelper(ACTION_PREFIX);

export const actionCreators = {
    ...storeHelper.defaultActionCreators(apiUrls.portal.users),
};

const initialState = {
    ...storeHelper.defaultInitialState,
};

export const reducer = (state, action) => {
    const stateFromDefaultActions = storeHelper.defaultReducer(state, action, initialState);

    if (stateFromDefaultActions !== null) {
        return stateFromDefaultActions;
    }

    switch (action.type) {
    default: {
        return state || initialState;
    }
    }
};
